import Vue from 'vue'
import VueAxios from 'vue-axios'
import LocalStorageHelper from '../local-storage/LocalStorageHelper'
import * as LocalStorageKeys from '../local-storage/LocalStorageKeys'
import router from '../router'

export default function setup () {
  Vue.axios.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    if (error.response && error.response.data) {
      if ((error.response.status === 401 && error.response.data.constructor === Array && error.response.data.includes('invalid_token')) || (error.response.status === 403 && (error.response.data.error_description && error.response.data.error_description === 'Bearer token not found'))) {
        try {
          Vue.router.push({path: '/auth/login'})
          if (Vue.socket) {
            Vue.socket.close()
          }
          Vue.router.resetRouter()
          LocalStorageHelper.remove(LocalStorageKeys.REFRESH_AUTH_TOKEN)
          return Promise.resolve('Logged out due to token not found')

        } catch (error) {
          console.log(error)
          return Promise.reject(error)
        }

      } else if (error.response.status === 403 && ((error.response.data.error_description && error.response.data.error_description === 'Token already expired') || (error.response.data.constructor === Array && error.response.data.includes('expired_token')))) {
        let data
        try {
          data = {
            refresh_token: LocalStorageHelper.get(LocalStorageKeys.REFRESH_AUTH_TOKEN),
            grant_type: 'refresh_token',
          }
        } catch (error) {
          return Promise.reject(error)
        }

        var encodedCredentials = btoa('1:secretp@ssword')

        Vue.auth.refresh({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + encodedCredentials
          },
          data: data,
          url: `${process.env.VUE_APP_AUTH_URL}/token/refresh`,
          method: 'POST'
        }).then(res => {
          LocalStorageHelper.set(LocalStorageKeys.REFRESH_AUTH_TOKEN, res.data.refresh_token)
          Vue.auth.token(null, res.data.access_token, false)
          location.reload()
          return Promise.resolve('Token refreshed')
        }).catch(error => {
          console.log('Error on refresh:', error)
          return Promise.reject(error)
        })
      }
    }
    return Promise.reject(error)
  })
}
